import { useRef, useState } from 'react';

interface PerformanceDataPoint {
    time: string;
    cpu: number;
    memory: number;
}

const MAX_POINTS = 120;

export function usePerformanceMetrics(
    cpu: number | undefined,
    memory: number | undefined
): PerformanceDataPoint[] {
    const bufferRef = useRef<PerformanceDataPoint[]>([]);
    const lastValuesRef = useRef<{ cpu: number; memory: number } | null>(null);
    const [, setTick] = useState(0);

    if (cpu !== undefined && memory !== undefined) {
        const prev = lastValuesRef.current;
        if (!prev || prev.cpu !== cpu || prev.memory !== memory) {
            lastValuesRef.current = { cpu, memory };
            bufferRef.current = [
                ...bufferRef.current.slice(-(MAX_POINTS - 1)),
                {
                    time: new Date().toLocaleTimeString(),
                    cpu: Number((cpu * 100).toFixed(2)),
                    memory: Number(memory.toFixed(2)),
                },
            ];
            setTick((t) => t + 1);
        }
    }

    return bufferRef.current;
}
